// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"AdminsList_pageHeader__3AKo3"};